import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';
import {
  BsTelephoneFill,
  BsWhatsapp,
  BsEnvelopeFill,
  BsGeoAltFill,
} from "react-icons/bs";

function Mumbaicarrentalservice() {



const cardData = {
  keyword: " Mumbai Car Rental Service",

headingDescription:
  "Omshree Cab provides trusted and professional Mumbai car rental service for travelers looking for comfortable, reliable, and hassle-free transportation across the city and nearby destinations. Whether you need a car for airport transfers, corporate travel, city sightseeing, family trips, or outstation journeys, our Mumbai car rental service offers well-maintained vehicles and experienced drivers to ensure a smooth ride. We provide flexible booking options including self-drive rental, chauffeur-driven cars, luxury car hire, and corporate packages. Our fleet includes air-conditioned sedans, SUVs, tempo travelers, and luxury cars suitable for solo travelers, families, tourists, and business groups. With punctual pickups from any location in Mumbai, 24/7 customer support, and transparent pricing, Omshree Cab is your reliable partner for all Mumbai car rental needs.",

topPlaces: [
  {
    title: "Gateway of India",
    description:
      "Gateway of India is one of Mumbai’s most iconic landmarks located along the Arabian Sea in South Mumbai. Built during the British era, the grand arch monument attracts thousands of visitors for photography, sightseeing, and ferry rides to Elephanta Island. The surrounding Colaba area is lively with street markets, cafes, and historic buildings, making it a perfect starting point for exploring the city. A Mumbai car rental service allows travelers to reach the Gateway comfortably and continue their sightseeing journey without worrying about traffic or parking."
  },
  {
    title: "Marine Drive",
    description:
      "Marine Drive is a scenic coastal road stretching along the Arabian Sea, famously called the Queen’s Necklace due to the lights that sparkle at night. Visitors enjoy evening walks, sunsets, and the refreshing sea breeze. Renting a car in Mumbai makes it easy to explore Marine Drive and nearby areas like Nariman Point and Chowpatty Beach comfortably while enjoying the iconic views and cityscape."
  },
  {
    title: "Juhu Beach",
    description:
      "Juhu Beach is one of Mumbai’s most famous beaches and a popular spot for locals and tourists alike. Visitors come to enjoy the sandy shore, sunset views, and Mumbai street foods such as pav bhaji, bhel puri, and pani puri. The beach is lively in the evenings and during festivals. Renting a car provides convenient access to Juhu Beach and nearby attractions, ensuring a relaxed and comfortable trip."
  },
  {
    title: "Siddhivinayak Temple",
    description:
      "Siddhivinayak Temple is a renowned religious site in Mumbai dedicated to Lord Ganesha. Devotees from across India visit to seek blessings, especially during festivals like Ganesh Chaturthi. The temple’s peaceful atmosphere and beautiful architecture attract tourists and pilgrims alike. Using a car rental service in Mumbai ensures a comfortable visit, avoiding traffic congestion and parking issues in the busy temple vicinity."
  },
  {
    title: "Bandra Worli Sea Link",
    description:
      "Bandra Worli Sea Link is one of Mumbai’s most modern engineering marvels, connecting Bandra and Worli across the Arabian Sea. The cable-stayed bridge offers breathtaking views of the water and city skyline, especially at sunset or night when it’s beautifully illuminated. Renting a car in Mumbai allows travelers to enjoy this scenic route comfortably while moving between South Mumbai and western suburbs."
  },
  {
    title: "Haji Ali Dargah",
    description:
      "Haji Ali Dargah is a famous mosque and shrine situated on an islet in the Arabian Sea. The white marble structure is connected to the city by a narrow walkway that appears during low tide. Visitors come to pray and experience the serene environment. Renting a car ensures easy access to this spiritual landmark without the hassle of public transport or parking."
  },
  {
    title: "Elephanta Caves",
    description:
      "Elephanta Caves are ancient rock-cut caves on Elephanta Island, a UNESCO World Heritage Site known for intricate sculptures dedicated to Lord Shiva. Visitors travel by ferry from the Gateway of India to explore the caves and scenic surroundings. A Mumbai car rental service allows seamless transportation to the ferry point, making the journey convenient and comfortable."
  },
  {
    title: "Sanjay Gandhi National Park",
    description:
      "Sanjay Gandhi National Park is a vast green forest area within Mumbai, offering trekking, cycling, and nature walks, along with historical Kanheri Caves. Visitors enjoy a day surrounded by natural beauty and wildlife. Renting a car provides hassle-free access from different parts of Mumbai, allowing tourists to explore the park efficiently."
  },
  {
    title: "Colaba Causeway",
    description:
      "Colaba Causeway is one of Mumbai’s busiest shopping streets, known for vibrant markets selling clothing, accessories, handicrafts, and souvenirs. The area also has cafes and restaurants offering local and international cuisine. A Mumbai car rental service allows travelers to comfortably reach this popular market and continue sightseeing in South Mumbai."
  },
  {
    title: "Hanging Gardens",
    description:
      "Hanging Gardens, also called Pherozeshah Mehta Gardens, are beautifully landscaped gardens on Malabar Hill, offering panoramic views of Marine Drive and the Arabian Sea. Visitors enjoy peaceful walks, photography, and a relaxing environment away from city noise. Renting a car ensures convenient access and flexibility to combine this scenic location with other nearby attractions."
  }
],



services: [
{
name: "Mumbai Car Rental Service",
description: "Mumbai car rental service provides comfortable and reliable transportation solutions for travelers exploring the city or planning intercity trips. Our fleet includes AC sedans, SUVs, and luxury vehicles suitable for business travel, tourism, and personal trips. Professional drivers ensure safe driving and punctual pickup services across Mumbai. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Ideal for city travel, airport transfers, and outstation journeys. Spacious interiors ensure comfortable seating during the ride. Flexible rental packages allow hourly, daily, or long-distance bookings. Reliable car rental services ensure smooth and convenient travel across Mumbai."
},
{
name: "Car Rental Mumbai",
description: "Car rental in Mumbai offers convenient vehicle hire for passengers seeking comfortable transportation within the city or to nearby destinations. Our fleet includes well-maintained AC sedans and SUVs suitable for both local and highway travel. Professional drivers ensure safe driving and punctual pickup services. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Mumbai. Ideal for business travel, tourism visits, and family trips. Spacious interiors ensure comfortable journeys for passengers. Flexible booking options allow easy vehicle reservations. Reliable car rental services ensure smooth travel experiences."
},
{
name: "Self Drive Car Rental Mumbai",
description: "Self drive car rental in Mumbai provides the freedom to travel independently without a driver. Our fleet includes modern cars suitable for city travel and weekend trips. Vehicles are well-maintained and equipped with safety features for comfortable driving. Pickup and drop locations are available across major areas of Mumbai. Ideal for travelers who prefer privacy and flexible travel schedules. Comfortable interiors ensure enjoyable road trips. Flexible rental plans allow hourly or daily bookings. Self drive car rental services provide convenient and independent travel experiences."
},
{
name: "Car Hire Mumbai",
description: "Car hire in Mumbai offers reliable transportation for passengers needing comfortable vehicles for city travel or outstation journeys. Our fleet includes AC sedans, SUVs, and premium vehicles designed for smooth road travel. Professional drivers ensure punctual pickup and safe driving services. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Ideal for business travel, tourism trips, and family outings. Spacious seating ensures relaxed journeys for passengers. Flexible rental options allow easy ride scheduling. Reliable car hire services ensure convenient transportation."
},
{
name: "Mumbai Car Hire Service",
description: "Mumbai car hire service provides professional transportation solutions for travelers seeking comfortable vehicles across the city. Our fleet includes modern AC sedans and SUVs suitable for daily travel and outstation trips. Professional drivers ensure punctual pickup and safe driving services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Mumbai. Ideal for corporate travel, tourism visits, and personal trips. Spacious interiors ensure comfortable journeys for passengers. Flexible rental packages allow convenient travel planning. Reliable car hire services ensure smooth transportation experiences."
},
{
name: "Car Rental Service Mumbai Airport",
description: "Car rental service at Mumbai Airport offers convenient transportation for passengers arriving or departing from the airport. Our fleet includes comfortable AC sedans and SUVs suitable for airport transfers and city travel. Professional drivers monitor flight schedules to ensure punctual pickup and drop services. Pickup services are available from Terminal 1 and Terminal 2 of Mumbai Airport. Ideal for business travelers, tourists, and family trips. Spacious interiors ensure comfortable airport travel. Flexible booking options allow advance reservations. Reliable airport car rental services ensure stress-free transportation."
},
{
name: "Luxury Car Rental Mumbai",
description: "Luxury car rental in Mumbai offers premium vehicles designed for travelers seeking high-end transportation. Our fleet includes luxury sedans and premium SUVs suitable for executive travel and special occasions. Professional chauffeurs ensure smooth driving and punctual pickup services. Pickup services are available across Mumbai including hotels, homes, offices, and airport terminals. Ideal for corporate executives, VIP guests, and wedding events. Spacious interiors provide superior comfort during travel. Flexible rental packages allow convenient booking. Luxury car rental services ensure stylish and comfortable journeys."
},
{
name: "Cheap Car Rental Mumbai",
description: "Cheap car rental in Mumbai provides affordable transportation options for passengers seeking budget-friendly travel. Our fleet includes economical AC sedans and compact cars suitable for city travel. Professional drivers ensure safe driving and punctual pickup services. Pickup services are available across residential areas, offices, hotels, and airport terminals. Ideal for students, daily commuters, and budget travelers. Comfortable interiors ensure relaxed journeys during travel. Flexible booking options allow convenient ride scheduling. Affordable car rental services ensure economical and reliable transportation."
},
{
name: "Corporate Car Rental Mumbai",
description: "Corporate car rental in Mumbai offers professional transportation solutions for business travelers and companies. Our fleet includes executive sedans and premium SUVs suitable for corporate meetings and business travel. Professional chauffeurs ensure punctual pickup and safe driving services. Pickup services are available across Mumbai including offices, hotels, and airport terminals. Ideal for corporate events, executive travel, and client meetings. Spacious interiors ensure comfortable journeys for business professionals. Flexible rental packages allow scheduled bookings. Reliable corporate car rental services ensure efficient business transportation."
},
{
name: "Outstation Car Rental Mumbai",
description: "Outstation car rental in Mumbai provides comfortable transportation for travelers planning trips outside the city. Our fleet includes AC sedans, SUVs, and luxury vehicles suitable for highway travel. Professional drivers ensure safe driving and punctual arrival at destinations. Pickup services are available from homes, hotels, offices, and airport terminals across Mumbai. Ideal for family vacations, pilgrimage tours, and weekend trips. Spacious interiors ensure comfortable journeys during long-distance travel. Flexible one-way and round-trip options allow convenient planning. Reliable outstation car rental services ensure smooth travel experiences."
}
],

tableData: [
["Mumbai Car Rental Service","Car Rental Mumbai"],
["Self Drive Car Rental Mumbai","Car Hire Mumbai"],
["Mumbai Car Hire Service","Car Rental Service Mumbai Airport"],
["Luxury Car Rental Mumbai","Cheap Car Rental Mumbai"],
["Corporate Car Rental Mumbai","Outstation Car Rental Mumbai"]
],



whychoose: [
  {
    WhyChooseheading: "Experienced Mumbai Drivers",
    WhyChoosedescription: "Our drivers are highly experienced in navigating Mumbai’s busy streets, traffic zones, and major highways. They ensure smooth travel whether you need a local ride, airport transfer, or outstation journey."
  },
  {
    WhyChooseheading: "Transparent Car Rental Pricing",
    WhyChoosedescription: "Omshree Cabs provides clear and transparent pricing for car rental services in Mumbai. We explain per-kilometer charges, hourly packages, and rental plans before booking so there are no hidden costs."
  },
  {
    WhyChooseheading: "24/7 Car Rental Availability",
    WhyChoosedescription: "Our Mumbai car rental service is available 24/7. Customers can book a car anytime for airport transfers, business travel, city sightseeing, or long-distance trips."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "Our fleet includes well-maintained and fully air-conditioned vehicles that are regularly cleaned and sanitized to provide a comfortable travel experience."
  },
  {
    WhyChooseheading: "Flexible Car Rental Options",
    WhyChoosedescription: "We offer flexible car rental plans including hourly rentals, full-day packages, airport pickup and drop, outstation travel, and long-term car hire for corporate clients."
  },
  {
    WhyChooseheading: "Wide Range of Vehicles",
    WhyChoosedescription: "Omshree Cabs offers multiple vehicle options including sedan cars, SUVs like Ertiga and Innova, and premium vehicles suitable for individuals, families, and corporate travelers."
  },
  {
    WhyChooseheading: "Doorstep Pickup Across Mumbai",
    WhyChoosedescription: "Our car rental service provides convenient pickup from homes, offices, hotels, railway stations, and airports anywhere in Mumbai."
  },
  {
    WhyChooseheading: "Trusted Car Rental Company in Mumbai",
    WhyChoosedescription: "Omshree Cabs is trusted by many travelers for reliable car rental services in Mumbai. Our punctual drivers, clean vehicles, and professional service ensure a smooth travel experience."
  }
]
};

const faqData = [
  { question: "Do you provide car rental services in Mumbai?", answer: "Yes, Omshree Cabs provides reliable car rental services in Mumbai for local travel, airport transfers, and outstation trips." },
  { question: "Can I book a car for hourly rental in Mumbai?", answer: "Yes, we offer hourly car rental packages for city travel, meetings, and sightseeing." },
  { question: "Do you provide airport pickup and drop services?", answer: "Yes, we provide airport pickup and drop services for Mumbai Airport including Terminal 1 and Terminal 2." },
  { question: "Which vehicles are available for car rental?", answer: "We offer sedan cars, SUVs like Ertiga and Innova, and premium vehicles depending on your travel requirements." },
  { question: "Is the car rental service available 24 hours?", answer: "Yes, Omshree Cabs provides 24/7 car rental services across Mumbai." },
  { question: "Do you provide outstation car rental from Mumbai?", answer: "Yes, we provide outstation car rental services from Mumbai to destinations like Pune, Lonavala, Nashik, Surat, and many other cities." },
  { question: "Are the rental vehicles air-conditioned?", answer: "Yes, all vehicles provided by Omshree Cabs are fully air-conditioned for comfortable travel." },
  { question: "Can I book a car rental online?", answer: "Yes, customers can easily book a car rental online or via phone for quick confirmation." },
  { question: "Is advance booking required?", answer: "Advance booking is recommended especially during weekends, holidays, and peak travel seasons." },
  { question: "Are vehicles sanitized before each trip?", answer: "Yes, all vehicles are cleaned and sanitized regularly to maintain passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Rohit Sharma",
    feedback:
      "We booked Omshree Cabs for a full-day car rental in Mumbai. The driver was professional and the car was very clean. Highly recommended service.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Neha Kulkarni",
    feedback:
      "Excellent car rental service in Mumbai. Easy booking, transparent pricing, and very comfortable travel experience.",
    rating: 5
  }
];




















































const Images = [
  { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cab" },
{ place: "/images/keyword/2.jpeg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
{ place: "/images/keyword/5.jpeg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
{ place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
{ place: "/images/keyword/7.jpeg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
{ place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
{ place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
{ place: "/images/keyword/11.jpeg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
{ place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
{ place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
{ place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
{ place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
{ place: "/images/keyword/16.jpeg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
{ place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
{ place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
{ place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
{ place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
{ place: "/images/keyword/21.jpeg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
{ place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
];













const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai Car Rental Service",
  "description": "Omshree Cab offers reliable Mumbai Car Rental Service with options for self-drive, luxury cars, corporate rentals, airport transfers, and outstation travel. Affordable fares, easy online booking, and trusted car hire service across Mumbai.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "3000"
  }
};




  return (
    <div>
      
<Helmet>
  <title>Mumbai Car Rental Service | Contact: +91 9892544084 | Omshree Cab</title>
  <meta 
    name="description" 
    content="Omshree Cab provides Mumbai car rental service for self-drive, luxury, corporate, airport, and outstation travel. Affordable fares and easy online booking for trusted car hire in Mumbai." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/39.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Omshree Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚙
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Omshree Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Omshree Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
       <div className="pc-contact">
      <h4 className="pc-title">Contact Information</h4>

      <div className="pc-grid">
        {/* Phones */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsTelephoneFill className="pc-icon" />
            <span>Phone Numbers</span>
          </header>

          <div className="pc-list">
            <a href="tel:+919892544084" className="pc-call">
              +91 9892544084
            </a>
          </div>

          <div className="pc-cta">
            <a
              href="https://wa.me/919892544084"
              target="_blank"
              rel="noopener noreferrer"
              className="pc-whats"
            >
              <BsWhatsapp /> WhatsApp
            </a>

            <a href="tel:+919892544084" className="pc-primary">
              Call Now
            </a>
          </div>
        </section>

        {/* Email */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsEnvelopeFill className="pc-icon" />
            <span>Email</span>
          </header>

          <a href="mailto:booking@omshreecabs.com" className="pc-email">
            booking@omshreecabs.com
          </a>
        </section>

        {/* Address */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsGeoAltFill className="pc-icon" />
            <span>Address</span>
          </header>

          <address className="pc-address">
            <strong>Omshree Cab</strong>
            <br />
           Shri Omkar Co-op Housing Society,
            <br />
            E-11/101, Sector 9,
Ghansoli (Gharonda),
            <br />
            Navi Mumbai, Maharashtra, India - 400701
          </address>
        </section>
      </div>
    </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaicarrentalservice;